export const CNC_LOCATION_QUERY_HISTORY_KEY = 'cnc_loc_query_history';
const MAX_HISTORY_ITEMS = 4;

export function useClickAndCollectLocationQueryHistory() {
  const get = (): string[] => {
    if (typeof window === 'undefined') {
      return [];
    }

    const raw = localStorage.getItem(CNC_LOCATION_QUERY_HISTORY_KEY);
    if (!raw) {
      return [];
    }

    try {
      return JSON.parse(raw) as string[];
    } catch {
      localStorage.removeItem(CNC_LOCATION_QUERY_HISTORY_KEY);
      return [];
    }
  };

  const add = (address: string) => {
    if (typeof window === 'undefined') {
      return;
    }

    const next = [address, ...get().filter((a) => a !== address)].slice(0, MAX_HISTORY_ITEMS);

    localStorage.setItem(CNC_LOCATION_QUERY_HISTORY_KEY, JSON.stringify(next));
  };

  const remove = (address: string) => {
    if (typeof window === 'undefined') {
      return;
    }
    const next = get().filter((existing) => existing !== address);

    localStorage.setItem(CNC_LOCATION_QUERY_HISTORY_KEY, JSON.stringify(next));
  };

  return {
    get,
    add,
    remove,
  };
}

export default useClickAndCollectLocationQueryHistory;
